import { Controller } from '@hotwired/stimulus'

import hljs from 'highlight.js/lib/core'
import bash from 'highlight.js/lib/languages/bash'
import crystal from 'highlight.js/lib/languages/crystal'
import css from 'highlight.js/lib/languages/css'
import graphql from 'highlight.js/lib/languages/graphql'
import javascript from 'highlight.js/lib/languages/javascript'
import json from 'highlight.js/lib/languages/json'
import python from 'highlight.js/lib/languages/python'
import ruby from 'highlight.js/lib/languages/ruby'
import shell from 'highlight.js/lib/languages/shell'
import sql from 'highlight.js/lib/languages/sql'
import swift from 'highlight.js/lib/languages/swift'
import typescript from 'highlight.js/lib/languages/typescript'
import SocialLikesNext from 'social-likes-next'

export default class PostController extends Controller {
  connect () {
    this.applyFormattingToPreBlocks()

    hljs.registerLanguage('bash', bash)
    hljs.registerLanguage('crystal', crystal)
    hljs.registerLanguage('css', css)
    hljs.registerLanguage('javascript', javascript)
    hljs.registerLanguage('python', python)
    hljs.registerLanguage('ruby', ruby)
    hljs.registerLanguage('swift', swift)
    hljs.registerLanguage('typescript', typescript)
    hljs.registerLanguage('shell', shell)
    hljs.registerLanguage('graphql', graphql)
    hljs.registerLanguage('json', json)
    hljs.registerLanguage('sql', sql)

    const socialLikes = this.element.querySelectorAll('.social-likes')

    socialLikes.forEach((share) => {
      SocialLikesNext(share)
    })

    this.element.querySelectorAll('pre code').forEach((element) => {
      hljs.highlightElement(element)
    })
  }

  applyFormattingToPreBlocks () {
    const preElements = this.element.querySelectorAll('pre')
    preElements.forEach(function (preElement) {
      // const regex = /(?!lang\-\\w\*)lang-\w*\W*/gm;
      const codeElement = document.createElement('code')
      if (preElement.childNodes.length > 1) {
        console.error('<pre> element contained nested inline elements (probably styling) and could not be processed. Please remove them and try again.')
      }
      const preElementTextNode = preElement.removeChild(preElement.firstChild)
      // let language = preElementTextNode.textContent.match(regex);
      // if (language) {
      //   language = language[0].toString().trim();
      //   preElementTextNode.textContent = preElementTextNode.textContent.replace(language, '');
      //   codeElement.classList.add(language, 'line-numbers');
      // }
      codeElement.append(preElementTextNode)
      preElement.append(codeElement)
    })
  }
}
